import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import { useTranslation } from 'react-i18next';

export function RouteErrorBoundary() {
  const error = useRouteError();
  const { t } = useTranslation('general');

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-3 p-8 text-center">
      <h1 className="text-xl font-semibold text-neut-prim">
        {t('route_error.title')}
      </h1>
      <p className="max-w-md text-sm text-neut-sec">{t('route_error.body')}</p>
      {/* A full page load, not a Link, so the broken React tree is thrown away. */}
      <a
        href="/dashboard"
        className="text-sm text-prim underline underline-offset-2"
      >
        {t('route_error.back')}
      </a>
    </main>
  );
}
